import { isString } from '@spt-tracking/utils';
const objectTypeContentMapping = {
    classifiedad: 'classified',
    notificationcontent: 'notification',
    businesstransaction: 'transaction',
    uielement: 'element',
};
const getObjectContentByType = (type = '') => objectTypeContentMapping[type.toLowerCase()] ?? type.toLowerCase();
function idIsFormatted(id) {
    return isString(id) && id?.startsWith('sdrn:');
}
export function generateObjectSDRN(id, providerId, type) {
    if (idIsFormatted(id)) {
        return id;
    }
    if ((isString(id) || Number.isFinite(id)) && isString(providerId) && isString(type)) {
        const contentType = getObjectContentByType(type);
        return `sdrn:${providerId}:${contentType}:${id}`;
    }
}
